import * as React from 'react';
import * as analytics from '../../../../analytics';
import { bindActionCreators } from 'redux';
import { ShowTimeProvider } from '../../ShowTimeContext';
import { IControlConfiguration, ISectionUIControlProps } from "../../interfaces/ISectionUIControlProps";
import SubentitiesList, {
     ISubentitiesListSettings, SubListControlSettings,
    SubentitiesListHierarchyContext,
    ISuggestedDataContext,
    ViewConfig
} from "../../../../components/common/SubentitiesList";
import { SectionHierarchyManager } from "../../../../components/utils/SectionHierarchyManager";
import { ProjectInfo } from '../../../../store/ProjectsListStore';
import { nameof, namesof } from '../../../../store/services/metadataService';
import {
    ITask, ITaskAttrs, buildMilestone, ISubentitySectionActions, IPredecessorInfo, sortTasksByRank, PredecessorType, buildPredecessorsMap, ISuggestedSubentity
} from '../../../../entities/Subentities';
import GroupSelectionPanel from './tasksControl/GroupSelectionPanel';
import * as Metadata from "../../../../entities/Metadata";
import { UserState } from "../../../../store/User";
import { connect } from 'react-redux';
import { ApplicationState } from "../../../../store/index";
import { getFirstDayOfWeekSetting } from "../../../../store/selectors/settingsSelectors";
import * as TasksTimeline from '../../../task/timeline';
import { ContextualMenuItemType, DayOfWeek, IContextualMenuItem, MessageBar, MessageBarType } from 'office-ui-fabric-react';
import { GroupInfo } from '../../CreateGroupPanel';
import {
    Dictionary, IUserInfo, StatusCategory, ISourceInfo, SourceInfo, ppmxTaskConnectionId, EntityType, IPatch,
    IWithSubViews, IWithSortBy, IWithScale, ProgressCalculationType, UpdateOptions, TaskType, ModeSwitchRecalculation, ModeSwitchRecalculationInfo
} from "../../../../entities/common";
import * as TimelineList from '../../timeline/TimelineList';
import * as utils from "../../timeline/utils";
import EntityGroupHeader, { EntityGroup } from '../../extensibleEntity/EntityGroupHeader';
import { withRouter, RouteComponentProps } from "react-router-dom";
import { arraysEqual, formatValue, notUndefined, toDate, toDictionaryById, waitForFinalEvent } from '../../../utils/common';
import { ProgressIcon } from '../../../common/ProgressFormatter';
import { ListGroupingProps } from '../../extensibleEntity/EntityDetailsList';
import KeyDateTooltipContent from '../../timeline/KeyDateTooltipContent';
import { ITimelineSegment } from '../../timeline/TimelineSegment';
import { ITimelineMarker } from '../../timeline/TimelineMarker';
import { allowEditReadOnlyProgress, allowEditTaskProgress, allowEditTasksProgress, allowedReadonlyProgressFields, AssignmentByDayUpdate, TaskHierarchy, TITLE_FIELD_ID } from '../../../../store/tasks';
import { SourceType, SourceType_, SourceTypeMap } from '../../../../store/ExternalEpmConnectStore';
import { SectionControlPlaceholder } from '../SectionPlaceholder';
import RefreshProjectButton from './projectSummaryControl/RefreshProjectButton';
import IterationSelect from '../../IterationSelect';
import { ungroupedGroup } from '../../inputs/GroupDropdown';
import * as NotificationsStore from '../../../../store/NotificationsStore';
import { ITimelineProps, MAX_ROWS_COUNT_FOR_CORRECT_DND } from '../../extensibleEntity/EntityTimelineList';
import { getAssigneeCalendars, handleDuration } from '../../../utils/duration';
import TaskBaseline from '../../../task/TaskBaseline';
import TaskSetBeselineConfirmation from '../../../task/TaskSetBeselineConfirmation';
import { post } from '../../../../fetch-interceptor';
import TaskModeSwitchRecalculationDialog from '../../../task/TaskModeSwitchRecalculationDialog';
import { IStyleSettings } from '../../timeline/TimelineList';
import { FilterHelper } from '../../../../store/task/filters';
import { FilterHelperProps } from '../../../../store/subentities/filters';
import { InlineInput, TextEditor } from '../../inputs/InlineAddInput';
import TaskPredecessors from '../../../task/TaskPredecessors/TaskPredecessors';
import TaskAssignments from '../../../task/TaskAssignments/TaskAssignments';
import { ITimelineRelation } from '../../timeline/TimelineRelation';
import { ICreationData } from '../../../../store/Subentity';
import { IWithActiveFilter } from '../../../../store/services/settingsService';
import { IWithStyleSettings, PreferenceUpdates, UserViewPreferencesUpdate, Views } from '../../../../store/services/viewSaver';
import * as StatusDescriptorFactory from '../../../../entities/StatusDescriptorFactory';
import { ConfirmationDialog } from '../../ConfirmationDialog';
import { isAllowedAsPredecessorByHierarchy, isTaskPredecessorHierarchyValid, messages, TaskProgressCalculator, TaskScheduleCalculator } from '../../../../components/task/Fields';
import { titleSuffixRender } from '../../../../components/mywork/TaskEditPanel';
import { IInputProps } from '../../interfaces/IInputProps';
import { PPMFeatures, Subscription, TenantState } from '../../../../store/Tenant';
import AISchedulePanel from '../../../project/AISchedulePanel';
import { v4 as uuidv4 } from 'uuid';
import { ViewService } from '../../../../services/ViewService';
import { TaskVarianceCalculator } from '../../../task/TaskVarianceCalculator';
import { TaskVariance } from '../../../task/TaskBaseline/TaskBaseline';
import { GroupSummary } from '../../../task/TaskGroupTooltipContent';
import * as TimeTrackingReportTimeMenu from '../../../../components/timeTracking/TimeTrackingReportTimeMenu';
import { TimeReportingPeriod } from '../../../../store/TimeReportingPeriodsStore';
import { getCopyScheduleTitle } from '../../CopyScheduleConfirmationDialog';
import { isExternalPredecessor } from '../../../../entities/Subentities';
import { PersistWorkloadGrid } from '../../../task/WorkloadGrid/PersistWorkloadGrid';
import { onScaleChanged } from '../../../resource/usage/ResourceUsageGrid/BaseUsageGrid';
import { UsagesControlSettings, WorkloadControlSettings } from '../../../task/WorkloadGrid/common';
import { Resource } from '../../../../store/ResourcesListStore';
import AssigneePickerInput from '../../inputs/AssigneePickerInput';
import { allTimeTypes, getTimeTypes, TimeType, timeTypesConfigMap } from '../../../task/WorkloadGrid/common';
import { TimeTypeSelector } from '../../../resource/usage/ResourceUsageCell';
import { IWithColumns } from '../../extensibleEntity/ListMenu';
import { IRow } from '../../timeline/TimelineList';
import {
    buildTaskFormFields, ConfigureTaskFormPanel, getEditedLayout, getTaskFormFields, getTaskFormSections
} from '../../../task/ConfigureTaskForm';
import { CommonOperations, contains } from '../../../../store/permissions';
import { CalendarDataSet } from '../../../../store/calendar/common';

type DraftTask = { id: string; insertBeforeId?: string; parentId?: string };
export const ProgressScale = [0, 25, 50, 75, 100];
const FeatureForAllTasksFilterMessage: string = "Feature is only available for All Tasks filter with no pre-filters.";
export type IActions = Omit<ISubentitySectionActions<ITask>, "create" | "update"> & {
    create: (data: ICreationData<ITaskAttrs>, withByDays?: boolean, options?: UpdateOptions) => void;
    update: (id: string, changes: Dictionary<unknown>, reloadByDays?: boolean, options?: UpdateOptions) => Promise<void>;
    createGroup: (group: Metadata.IBaseGroupInfo) => void;
    updateGroup: (group: Metadata.Group) => void;
    removeGroup: (groupId: string) => void;
    reorderGroups: (groupIds: string[]) => void;
    bulkUpdate: (items: IPatch<ITask>[]) => void;
    bulkCreate: (items: ICreationData[], options?: UpdateOptions) => void;
    reportTime: (task: ITask, seconds: number, date: Date) => void;
    setBaseline: (entities: string[]) => void;
    indent: (ids: string[], parentId?: string) => void;
    outdent: (ids: string[], parentId?: string) => void;
    rollupTasks: (ids: string[]) => void;
    applyCalendars: (ids: string[]) => void;
    updateCalculationMode: (isAutoMode: boolean, ids: string[], recalculation?: ModeSwitchRecalculation) => void;
    updateTaskType: (taskType: TaskType, ids: string[]) => void;
    updateEffortDriven: (effortDriven: boolean, ids: string[]) => void;
    copyToPpmxSchedule: (sourceType: SourceType) => void;
    updateAssignmentsByDay: (updates: AssignmentByDayUpdate[]) => void;
    saveTaskFormFields?: (sourceType: SourceType, fields: string[]) => void;
}

type ICustomElementRender = Dictionary<(props: IInputProps, state: ITaskAttrs, field: Metadata.Field) => JSX.Element>;
export type IDataContext = ISuggestedDataContext<ITask> & {
    activeSourceInfo: ISourceInfo;
    groups?: Metadata.Group[];
    fakeFields?: Metadata.Field[];
    readOnlyFields?: ((entity: ITask) => string[]) | string[];
    calendar: CalendarDataSet;
    calendarsById: Dictionary<CalendarDataSet>;
}
type SystemControlSettings = {
    timeline: IWithSubViews & IWithSortBy,
    details: IWithSubViews & IWithSortBy,
    usage?: UsagesControlSettings
} & IWithActiveFilter;

type StyleValues = {
    showBaseline: boolean;
    showTimeWithDate: boolean;
    showActualDates: boolean;
    showCriticalPath: boolean;
}

type ControlSettings = {
    viewType: Views;
    timeline: IWithScale & IWithStyleSettings<StyleValues>;
    usage: UsagesControlSettings
} & {
    [key in SourceType]: SystemControlSettings
}
export type IConfiguration = IControlConfiguration<IActions, ControlSettings, IDataContext>;
type ExternalTasksControlProps = ISectionUIControlProps<IActions, ISubentitiesListSettings, ProjectInfo & {suggestedSubentities: Dictionary<(ITask & ISuggestedSubentity)[]>}, ICustomElementRender, ControlSettings, IDataContext>;
type StateProps = {
    user: UserState;
    resources: Dictionary<Resource>;
    isListLoading: boolean;
    isListUpdating: boolean;
    fields: Metadata.Field[];
    tenant: TenantState;
    connectionTaskTypes?: string[];
    firstDayOfWeek: DayOfWeek;
    periods: TimeReportingPeriod[];
    taskFormSections?: Metadata.Section[];
    isEditingLayout: boolean;
    canManageConfiguration: boolean;
};
type ActionsProps = {
    notificationsActions: typeof NotificationsStore.actionCreators;
}

type Props = ExternalTasksControlProps & StateProps & ActionsProps & RouteComponentProps<{}>;

type State = {
    tasks: ITask[];
    draftTasks: DraftTask[];
    groups: EntityGroup[] | undefined;
    preFilterItems: Metadata.PreFilterOption<ITask>[];
    readOnly?: boolean;
    isTimelineDnDMessageShown?: boolean;
    setBaselineSelectedEntities?: ITask[];
    isOpenAutoModeConfirmation?: string[];
    modeSwitchRecalculation?: { ids: string[], info: ModeSwitchRecalculationInfo };
    isAISchedulePanelOpen: boolean;
    selectedGroup?: EntityGroup;
    expandedInFilter: string[];
    isConfigureTaskFormOpen?: boolean;
}

const SubList = SubentitiesList<ITask>();

const SHOW_TIME_WITH_DATE_LABEL = 'Show Time with Date';

const ppmxStyleSettings: IStyleSettings<StyleValues> = {
    showBaseline: { label: 'Show Baseline' },
    showTimeWithDate: { label: SHOW_TIME_WITH_DATE_LABEL },
    showActualDates: { label: 'Show Actual Start/Due' },
    showCriticalPath: { label: 'Show Critical Path' }
}

const externalStyleSettings: IStyleSettings<StyleValues> = {
    showTimeWithDate: { label: SHOW_TIME_WITH_DATE_LABEL }
}

const listStyleSettings: IStyleSettings<StyleValues> = {
    showTimeWithDate: { label: SHOW_TIME_WITH_DATE_LABEL }
}

const workloadStyleSettings: IStyleSettings<StyleValues> = {
    showTimeWithDate: { label: SHOW_TIME_WITH_DATE_LABEL }
}

//after filter change check same filter on ui in DataService.GetProjectTasksDailyCalculation.cs
function InDateRangeFilter(begin: Date, end: Date): (entity: ITask) => boolean {
    return (_) =>
        (!!_.attributes.StartDate && !!_.attributes.DueDate
            && toDate(_.attributes.StartDate)! < begin
            && toDate(_.attributes.DueDate)!.getEndOfDay() > end)
        || (!!_.attributes.StartDate
            && toDate(_.attributes.StartDate)! >= begin
            && toDate(_.attributes.StartDate)!.getEndOfDay() <= end)
        || (!!_.attributes.DueDate
            && toDate(_.attributes.DueDate)! >= begin
            && toDate(_.attributes.DueDate)!.getEndOfDay() <= end);
}

function defaultPrefilterItems(firstDayOfWeek: DayOfWeek): Metadata.PreFilterOption<ITask>[] {
    const today = {
        begin: new Date().getBeginOfDay(),
        end: new Date().getEndOfDay()
    };
    const week = new Date().getThisWeek(firstDayOfWeek);

    return [
        {
            key: Metadata.TaskPrefilterKey.today,
            name: 'Today Tasks',
            predicate: InDateRangeFilter(today.begin, today.end)
        },
        {
            key: Metadata.TaskPrefilterKey.thisweek,
            name: 'This Week Tasks',
            predicate: InDateRangeFilter(week.start, week.end)
        },
        {
            key: Metadata.TaskPrefilterKey.late,
            name: 'Late Tasks',
            predicate: _ => _.attributes.Progress !== 100 && !!_.attributes.DueDate && toDate(_.attributes.DueDate)! < today.begin
        },
        {
            key: Metadata.TaskPrefilterKey.nodates,
            name: 'No Dates',
            predicate: _ => !_.attributes.StartDate && !_.attributes.DueDate
        },
        {
            key: Metadata.TaskPrefilterKey.noassignments,
            name: 'No Assignments',
            predicate: _ => !_.attributes.AssignedTo?.length
        }
    ];
}
const nonFilterableFields = namesof<ITaskAttrs>(['Group', 'Predecessor']);
const timeDelay = 600;

const getGroupKey = (task: ITask): string => task.attributes.Group?.id || ungroupedGroup.key

const MIN_COUNT_TO_LINK = 2;
class TasksControl extends React.Component<Props, State> {
    private _inlineTasksToCreate: ICreationData[];
    private _debouncedOnSaveInlineTask: () => void;
    private _hierarchy: SectionHierarchyManager<ITask, SubentitiesListHierarchyContext<ITask>>;

    private _buildRowShowCriticalPath: boolean | undefined = undefined;
    private _buildRowTasksMap: Dictionary<ITask> | undefined = undefined;
    private _buildRowRelationsMap: Dictionary<TasksTimeline.TaskRelation[]> | undefined = undefined;
    private _buildRowFn: ((task: ITask) => IRow) | undefined = undefined;

    private _getBuildRow(
        showCriticalPath: boolean,
        tasksMap: Dictionary<ITask>,
        relationsMap: Dictionary<TasksTimeline.TaskRelation[]>
    ): (task: ITask) => IRow {
        if (
            this._buildRowFn &&
            this._buildRowShowCriticalPath === showCriticalPath &&
            this._buildRowTasksMap === tasksMap &&
            this._buildRowRelationsMap === relationsMap
        ) {
            return this._buildRowFn;
        }
        this._buildRowShowCriticalPath = showCriticalPath;
        this._buildRowTasksMap = tasksMap;
        this._buildRowRelationsMap = relationsMap;
        this._buildRowFn = (task: ITask) => TasksTimeline.buildTimelineItem(task, tasksMap, relationsMap[task.id], showCriticalPath);
        return this._buildRowFn;
    }

    constructor(props: Props) {
        super(props);
        this._inlineTasksToCreate = [];
        this._debouncedOnSaveInlineTask = waitForFinalEvent(this._bulkSaveInlineTasks, timeDelay, 'bulk-save-inline-tasks');
        this._hierarchy = new SectionHierarchyManager<ITask, SubentitiesListHierarchyContext<ITask>>({
            fieldId: TITLE_FIELD_ID,
            collapseItemsOnSorting: true,
            allowDrag: () => {
                const context = this._hierarchy.getContext();
                return TaskHierarchy.allowDrag(this.props.datacontext.activeSourceInfo.type, context);
            },
            isHierarchicalSort: () => TaskHierarchy.isHierarchicalSort(this.props.datacontext.activeSourceInfo.type),
            filterRootHierarchyItems: (tasks) => TaskHierarchy.filterRootHierarchyItems(this.props.datacontext.activeSourceInfo.type, tasks),
            isHierarchyView: (context) => TaskHierarchy.isHierarchyView(this.props.datacontext.activeSourceInfo.type, context),
            getDefaultOutlineLevel: () => TaskHierarchy.getDefaultLevel(this.props.datacontext.activeSourceInfo.type),
            getItemIsParent: (entity: ITask): boolean => {
                const context = this._hierarchy.getContext();
                const isHierarchyView = TaskHierarchy.isHierarchyView(this.props.datacontext.activeSourceInfo.type, context);
                return (isHierarchyView && !!entity.hierarchy.isParent)
                    || (!isHierarchyView && !!entity.hierarchy.isParent
                        && (!!this._hierarchy.getParentKey(entity) || this.state.expandedInFilter.includes(this._hierarchy.getKey(entity))));
            },
            getItemId: (entity) => entity.sourceType === SourceType.Ppmx ? entity.id : entity.externalId,
            getItemParentId: (entity) => entity.sourceType === SourceType.Ppmx ? entity.hierarchy.parentId : entity.hierarchy.parentExternalId,
            getGroupKey: getGroupKey,
            supportsOutline: () => TaskHierarchy.isSupportOutline(this.props.datacontext.activeSourceInfo.type)
        });

        this.state = {
            tasks: [],
            draftTasks: [],
            groups: undefined,
            preFilterItems: props.datacontext ? this._getPrefilterItems()[props.datacontext.activeSourceInfo.type] : [],
            isTimelineDnDMessageShown: this._checkDnDLimitation(props),
            isAISchedulePanelOpen: false,
            expandedInFilter: [],
        };
    }

    componentWillMount() {
        const groups = this._buildGroups(this.props);
        const readOnly = !this.props.entity.canCollaborate || this.props.datacontext.activeSourceInfo.connectionId !== ppmxTaskConnectionId

        this.setState({ tasks: Array.from(this.props.entity.tasks || []), draftTasks: [], groups, readOnly });
    }

    componentWillReceiveProps(nextProps: Props) {
        if (this.props.entity.tasks !== nextProps.entity.tasks
            || this.props.datacontext.groups !== nextProps.datacontext.groups
            || !arraysEqual(this.props.connectionTaskTypes, nextProps.connectionTaskTypes))
        {
            const groups = this._buildGroups(nextProps);
            this.setState({ groups, tasks: Array.from(nextProps.entity.tasks || []), draftTasks: [] });
        }
        const newReadonly = !nextProps.entity.canCollaborate || nextProps.datacontext.activeSourceInfo.connectionId !== ppmxTaskConnectionId
        if (newReadonly != this.state.readOnly) {
            this.setState({ readOnly: newReadonly });
        }

        if (this.props.datacontext.activeSourceInfo.type !== nextProps.datacontext.activeSourceInfo.type) {
            this.setState({ preFilterItems: this._getPrefilterItems()[nextProps.datacontext.activeSourceInfo.type] });
        }

        const isTimelineDnDMessageShown = this._checkDnDLimitation(nextProps, this.state.isTimelineDnDMessageShown)
        if (isTimelineDnDMessageShown !== undefined) {
            this.setState({ isTimelineDnDMessageShown });
        }
    }

    render() {
        const { isConfigureMode, switchToConfigureMode, onConfigureModeComplete, entity, actions, settings, isFullScreen,
            editProps, inlineEditProps, isListLoading, isListUpdating, datacontext, user, tenant, onSaveSettings } = this.props;
        const activeSourceInfo: ISourceInfo = datacontext.activeSourceInfo;

        if (SourceType_.isTaskUnactualVersion(activeSourceInfo) || (SourceInfo.syncFailed([activeSourceInfo]) && !isListLoading && (!entity.tasks || entity.tasks.length === 0))) {
            return <SectionControlPlaceholder
                key="no-data"
                iconName="TaskManagementSectionIcon"
                title="Tasks section is empty">
                <div className="align-center">
                    <div>
                        To see actual {SourceTypeMap[activeSourceInfo.type]} data, please click Refresh
                    </div>
                    <RefreshProjectButton entity={entity} className="tasks-control" />
                </div>
            </SectionControlPlaceholder>;
        }

        if (!entity.isSyncable && activeSourceInfo.type != SourceType.Ppmx && SourceType_.isTaskViewable(activeSourceInfo) && !isListLoading && (!entity.tasks || entity.tasks.length === 0)) {
            return <SectionControlPlaceholder
                key="no-data"
                iconName="TaskManagementSectionIcon"
                title="Tasks synchronization is in progress">
                <div className="align-center">
                    <div>
                        Please wait until synchronization is completed
                    </div>
                </div>
            </SectionControlPlaceholder>;
        }

        const { readOnly } = this.state;
        const relationsMap = (entity.tasks || [])?.reduce<Dictionary<TasksTimeline.TaskRelation[]>>((acc, _) => {
            if (_.attributes.Predecessor?.length) {
                _.attributes.Predecessor.forEach(predecessor => {
                    if (isExternalPredecessor(predecessor)) {
                        acc[_.id] = [...(acc[_.id] ?? []), { relatedId: predecessor.id, type: predecessor.type, isExternal: true, isReverse: true }];
                        return;
                    }

                    acc[predecessor.id] = [...(acc[predecessor.id] ?? []), { relatedId: _.id, type: predecessor.type }];
                    //same nail as in roadmaps
                    //needed for correct rendering svg during export to png
                    acc[_.id] = [...(acc[_.id] ?? []), { relatedId: predecessor.id, type: predecessor.type, isReverse: true }];
                })
            }
            return acc;
        }, {});
        const tasksMap = toDictionaryById(entity.tasks || []);
        const showCriticalPath = this.props.controlSettings.timeline.styleSettingValues?.showCriticalPath === true;
        const timelineProps: ITimelineProps = {
            buildRow: this._getBuildRow(showCriticalPath, tasksMap, relationsMap),
            rebuildKey: showCriticalPath,
            renderSegmentContent: TasksTimeline.renderSegmentContent,
            renderSegmentTooltipContent: (row, segment) => TasksTimeline.renderSegmentTooltipContent(row, segment, this._openTask, this.props.entity.id),
            renderMarkerTooltipContent: _ => <KeyDateTooltipContent
                keyDate={buildMilestone(_.entity as ITask)!}
                createdFromType={EntityType.Task}
                onClick={() => this._openTask(_.entity as ITask)} />,
            onSegmentClick: _ => this._openTask(_.entity as ITask),
            onMarkerClick: _ => this._openTask(_.entity as ITask),
            onSegmentChange: readOnly ? undefined : (row: TimelineList.IRow, _segment, delta: Partial<ITimelineSegment>) =>
                this._updateTaskDates(row.entity as ITask, delta.startDate, delta.finishDate?.getBeginOfDay()),
            onMarkerChange: readOnly ? undefined : (row: TimelineList.IRow, _marker, delta: Partial<ITimelineMarker>) => {
                const task = row.entity as ITask;
                let startDate: Date | undefined = undefined;
                if (task.attributes.StartDate) {
                    //for milestones, keep duration unchanged
                    const duration = Math.round(utils.diffDays(toDate(task.attributes.StartDate)!, toDate(task.attributes.DueDate)!));
                    startDate = delta.date!.clone().addDays(-duration);
                }

                this._updateTaskDates(task, startDate, delta.date);
            },
            buildRelationCommands: this._buildTimelineRelationCommands,
            timelineGrouping: this._buildGrouping(),
            styling: {
                settings: activeSourceInfo.type === SourceType.Ppmx ? ppmxStyleSettings : externalStyleSettings,
                values: this.props.controlSettings.timeline.styleSettingValues,
                onChange: (key, value) => onSaveSettings?.(PreferenceUpdates.viewType(Views.Timeline, PreferenceUpdates.style(key, value)))
            },
        };
        const listGrouping: ListGroupingProps = {
            getGroupKey: getGroupKey,
            renderGroupHeader: (group, isCollapsed, isSelected, toggleCollapse, toggleSelect) =>
                <EntityGroupHeader group={group}
                    isCollapsed={isCollapsed}
                    isSelected={isSelected}
                    onToggleCollapse={toggleCollapse}
                    onToggleSelect={toggleSelect}
                    onGroupNameClick={readOnly ? undefined : switchToConfigureMode}
                    renderCounter={group.count ?
                        (grp) => <span className="subitems-counter"
                            title={`${grp.data.tasksCounts.complete} task${grp.data.tasksCounts.complete == 1 ? '' : 's'} ` +
                                `out of ${grp.count} in the group ${grp.data.tasksCounts.complete == 1 ? 'is' : 'are'} completed`}>
                            {grp.data.tasksCounts.complete} / {grp.count}
                        </span>
                        : () => <span className="subitems-counter" title={`0 tasks in group`}>0</span>}
                />,
            renderGroupFooter: readOnly ? undefined : (group) => this.renderGroupFooter(group, user, tenant)
        };

        const metadataGroups = this._getGroups(this.props);
        const aiEnabled = Subscription.contains(this.props.tenant.subscription, PPMFeatures.AiInsights);
        const showTimeWithDate = this.props.controlSettings.timeline?.styleSettingValues?.showTimeWithDate ?? false;
        const controlSettings = this._getControlSettings();
        return <ShowTimeProvider value={showTimeWithDate}>
            <SubList
                isFullScreen={isFullScreen}
                sectionId={this.props.sectionId}
                controlId={this.props.id}
                parentEntityId={this.props.entity.id}
                parentEntityType={this.props.entityType}
                timelineProps={timelineProps}
                listStyling={{
                    settings: listStyleSettings,
                    values: this.props.controlSettings.timeline.styleSettingValues,
                    onChange: (key, value) => onSaveSettings?.(PreferenceUpdates.viewType(Views.Timeline, PreferenceUpdates.style(key, value)))
                }}
                groups={this.state.groups}
                listGrouping={listGrouping}
                readOnly={!!readOnly}
                allowExtensions={this.props.entity.canCollaborate}
                fakeFields={datacontext.fakeFields}
                subentityInfo={{
                    subentityType: EntityType.Task,
                    subentityTypeLabel: "Task",
                    subentityCollectionName: nameof("tasks", this.props.entity)
                }}
                suggestedInfo={this.props.datacontext?.suggestedInfo ? {
                    ...this.props.datacontext.suggestedInfo,
                    suggestedEntities: this.props.entity ? this.props.entity.suggestedSubentities?.[this.props.datacontext.suggestedInfo.suggestedType] ?? [] : []
                } : undefined}
                isArchived={this.props.entity.isArchived}
                useViews
                useFilters
                preFilterItems={this.state.preFilterItems}
                sourceType={activeSourceInfo.type}
                entities={this.state.tasks}
                entitiesIsLoading={isListLoading}
                entitiesIsUpdating={isListUpdating}
                settings={settings}
                actions={{
                    ...actions,
                    create: this._create,
                    update: this._update,
                    exportToFile: actions.exportToFile && ((type, label, fields, ids, suggestedIds, viewType) =>
                        actions.exportToFile!(type, label, fields, ids, suggestedIds, viewType, showTimeWithDate)),
                }}
                commandsConfig={{
                    add: {
                        title: "Create a new task, it will be added to the end of the tasks list"
                    },
                    aiGeneration: {
                        hidden: !Subscription.contains({features: tenant.subscription.allFeatures}, PPMFeatures.AiInsights),
                        action: () => {
                            analytics.trackEvent("Start with AI Schedule", user);
                            this.setState({ isAISchedulePanelOpen: true })
                        },
                        name: "Generate with AI",
                        title: !aiEnabled
                            ? "To use AI features, PPM Insights AI should be enabled in the tenant by PPM Express Administrator"
                            : undefined,
                        disabled: !aiEnabled
                    },
                    outline: {
                        disabled: () => !this._isHierarchyView(),
                        title: () => !this._isHierarchyView() ? FeatureForAllTasksFilterMessage : undefined,
                    }
                }}
                mandatoryEditFields={this._getTaskFormFields()}
                nonFilterableFields={nonFilterableFields}
                readOnlyFields={datacontext.readOnlyFields}
                editProps={editProps}
                inlineEditProps={{ ...inlineEditProps, inlineEditing: !readOnly }}
                onItemRender={this._onListItemRender}
                emptyScreen={{
                    iconName: 'TaskManagementSectionIcon',
                    title: activeSourceInfo.type == SourceType.Ppmx ? 'Welcome to PPM Express Task Management!' : 'Welcome to Task Management!',
                    description: activeSourceInfo.type == SourceType.Ppmx ? 'You can use this section to manage tasks for a current project.'
                        : `This section shows tasks synchronized from ${SourceTypeMap[activeSourceInfo.type]}`
                }}
                externalCommands={{
                    actionsCommandItems: this._buildActionsCommandItems,
                    selectionModeCommands: this._buildSelectionModeCommands
                }}
                getDeletionMessage={(selectedItems: ITask[]) => selectedItems.length === 1
                    ? `Are you sure you want to delete task "${selectedItems[0].attributes.Name}"?`
                    : `Are you sure you want to delete ${selectedItems.length} tasks?`
                }
                renderDeleteDialogContent={(selectedItems: ITask[]) => {
                    const msgs: string[] = [];

                    if (selectedItems.some(_ => _.hierarchy.isParent)) {
                        msgs.push("Deleting the task will delete all its subtasks as well.");
                    }

                    const milestones = selectedItems.filter(_ => _.attributes.IsMilestone);
                    if (milestones.length > 0) {
                        msgs.push(selectedItems.length === 1
                            ? 'Related milestone will be deleted as well.'
                            : `${milestones.length} related milestone${milestones.length > 1 ? 's' : ''} will be deleted as well.`
                        );
                    }

                    return msgs.length
                        ? <MessageBar messageBarType={MessageBarType.warning} isMultiline>
                            {msgs.map((msg, index) => <>{msg}{!index && <br />}</>)}
                        </MessageBar>
                        : undefined;
                }}
                buildEntityFilterHelper={this._buildFilterHelper}
                hierarchy={this._hierarchy}
                entityPanelProps={{
                    ...(this._getConfiguredTaskFormFields() ? { displayFields: [] } : {}),
                    mandatoryEditableFields: (task: ITask) => allowEditReadOnlyProgress(task, user.resource?.id) ? allowedReadonlyProgressFields : undefined,
                    extraTabs: [
                        activeSourceInfo.type === SourceType.Ppmx || activeSourceInfo.type === SourceType.Spo
                            ? {
                                key: 'assignments',
                                label: 'Assignments',
                                renderHeaderSecondaryText: () => "Add assignment(s) for the task, then define assignment attributes.",
                                renderBody: (task: ITask, onChange: (fieldName?: string, fieldValue?: unknown, extra?: Dictionary<unknown>) => void) => <TaskAssignments
                                    readonly={!!readOnly}
                                    task={task as ITask}
                                    onChange={onChange}
                                />
                            }
                            : undefined,
                        activeSourceInfo.type === SourceType.Ppmx || activeSourceInfo.type === SourceType.Spo
                            ? {
                                key: 'predecessors',
                                label: 'Predecessors',
                                renderHeaderSecondaryText: () => !this.props.entity.isPrivate 
                                    ? "Add predecessor(s) and external predecessor(s) for the task, then select the dependency type and optionally set lead or lag time."
                                    : "Add predecessor(s) for the task, then select the dependency type and optionally set lead or lag time.",
                                renderBody: (task: ITask, onChange: (fieldName?: string, fieldValue?: unknown, extra?: Dictionary<unknown>) => void) => <TaskPredecessors
                                    readonly={!!readOnly}
                                    task={task as ITask}
                                    tasks={this.props.entity.tasks || []}
                                    project={this.props.entity}
                                    onChange={onChange}
                                    calendar={this.props.datacontext.calendar}
                                    shiftZeroDayMilestoneWithFSPredecessorToNextWorkingDay={
                                        this.props.entity.settings?.shiftZeroDayMilestoneWithFSPredecessorToNextWorkingDay
                                        ?? true}
                                    resources={this.props.resources}
                                    calendarsById={this.props.datacontext.calendarsById}
                                    useResourceCalendar={this.props.entity.settings.useResourceCalendar}
                                />
                            }
                            : undefined, 
                        activeSourceInfo.type === SourceType.Ppmx || activeSourceInfo.type === SourceType.Spo
                            ? {
                                key: 'baseline',
                                label: 'Baseline',
                                renderHeaderSecondaryText: () => `View the task baseline, its current state and variance value`,
                                renderBody: (updatedTask: ITask) => <TaskBaseline task={updatedTask} variance={this._getTaskVariance(updatedTask)} />
                            }
                            : undefined
                    ].filter(notUndefined)
                }}
                controlSettings={controlSettings}
                onSaveSettings={onSaveSettings ? this._onSaveSettings : undefined}
                entityPanelHeader={{
                    suffixRender: titleSuffixRender,
                    showFullScreenMode: true
                }}
                menu={{
                    isEnabled: true,
                    mandatoryFields: ViewService.getViewMandatoryFields(EntityType.Risk),
                    getItemCommands: this._getItemCommands,
                }}
                resetExpandedAfterFilterChange
                customView={controlSettings.viewType === Views.Usage ? this._getUsageView() : undefined}
            />
            {isConfigureMode && metadataGroups &&
                <GroupSelectionPanel
                    groups={metadataGroups}
                    onDismiss={onConfigureModeComplete}
                    reorderGroups={this.reorderGroups}
                    allowCreateGroups={entity.canCollaborate}
                    allowEditGroups={entity.canCollaborate}
                    saveGroup={this.saveGroup}
                    removeGroup={this.removeGroup}
                    entityName={{ singular: "Task Group", plural: "Task Groups" }}
                    removeDialog={{ messageBuilder: this.removeTaskGroupDialogMessageBuilder }} />}
            {this.state.setBaselineSelectedEntities &&
                <TaskSetBeselineConfirmation
                    selectedItems={this.state.setBaselineSelectedEntities}
                    onDismiss={() => this.setState({ setBaselineSelectedEntities: undefined })}
                    onConfirm={() => this._setBaseline(this.state.setBaselineSelectedEntities!)}
                />}
            {this.state.isOpenAutoModeConfirmation && <ConfirmationDialog
                onDismiss={() => this.setState({ isOpenAutoModeConfirmation: undefined })}
                onYes={() => {
                    this.props.actions.updateCalculationMode(true, this.state.isOpenAutoModeConfirmation!);
                    this.setState({ isOpenAutoModeConfirmation: undefined });
                }}
                onNo={() => { }}
                yesButtonProps={{ text: "Confirm" }}
                noButtonProps={{ text: "Cancel" }}
                dialogContentProps={{
                    title: 'Confirmation',
                    subText: 'Are you sure you want to apply Auto mode to the selected tasks?'
                }} >
                <MessageBar messageBarType={MessageBarType.warning} isMultiline>
                    Values in progress-related fields will be re-calculated for these tasks without the possibility to undo the re-calculation.
                </MessageBar>
            </ConfirmationDialog>}
            {this.state.modeSwitchRecalculation && <TaskModeSwitchRecalculationDialog
                info={this.state.modeSwitchRecalculation.info}
                onDismiss={() => this.setState({ modeSwitchRecalculation: undefined })}
                onApply={recalculation => {
                    this.props.actions.updateCalculationMode(true, this.state.modeSwitchRecalculation!.ids, recalculation);
                    this.setState({ modeSwitchRecalculation: undefined });
                }} />}
            {
                this.state.isConfigureTaskFormOpen && <ConfigureTaskFormPanel
                    fields={this.props.fields}
                    fieldNames={this._getTaskFormFields()}
                    onSave={fieldNames => {
                        this.props.actions.saveTaskFormFields?.(activeSourceInfo.type, fieldNames);
                        this.setState({ isConfigureTaskFormOpen: false });
                    }}
                    onDismiss={() => this.setState({ isConfigureTaskFormOpen: false })}
                />
            }
            {
                this.state.isAISchedulePanelOpen && <AISchedulePanel
                    projectId={this.props.entity.id}
                    projectDescription={this.props.entity.attributes.Description}
                    startDate={this.props.entity.attributes.StartDate}
                    finishDate={this.props.entity.attributes.FinishDate}
                    groups={metadataGroups!}
                    group={this.state.selectedGroup ? metadataGroups?.find(_ => _.id === this.state.selectedGroup!.key) : undefined}
                    onDismiss={() => this.setState({ isAISchedulePanelOpen: false, selectedGroup: undefined })} />
            }
        </ShowTimeProvider>;
    }
    private _getUsageView = () => {
        const { entity, controlSettings, datacontext, onSaveSettings, settings, actions} = this.props;
        const { readOnly } = this.state;
        const workloadOnSaveSettings = (update: UserViewPreferencesUpdate, sendToServer?: boolean) =>
            onSaveSettings?.(PreferenceUpdates.viewType(Views.Usage, update as any), sendToServer);
        
        const viewConfig: ViewConfig<ITask> = {
            displayFields: controlSettings?.usage?.displayFields ?? [],
            onDisplayFieldsChange: (f: string[]) => { workloadOnSaveSettings?.(PreferenceUpdates.displayFields(f)); },
            draggableEvents: {},
            styling: {
                settings: workloadStyleSettings,
                values: controlSettings.timeline.styleSettingValues,
                onChange: (key, value) => onSaveSettings?.(PreferenceUpdates.viewType(Views.Timeline, PreferenceUpdates.style(key, value)))
            }
        };

        const timeType = getTimeTypes(this.props.controlSettings);
        const farCommands: IContextualMenuItem[] = [
            {
                key: 'grouping',
                name: `Group by: ${controlSettings?.usage?.grouping === 'Resource' ? 'Resource' : 'Task'}`,
                iconProps: { iconName: 'ViewListGroup' },
                subMenuProps: {
                    items: ['Task', 'Resource'].map(_ => ({
                        key: _,
                        name: _,
                        canCheck: true,
                        checked: controlSettings?.usage?.grouping === _,
                        onClick: () => workloadOnSaveSettings?.(PreferenceUpdates.grouping(_))
                    }))
                }
            },
            {
                key: 'timeType',
                onRender: () => <TimeTypeSelector<TimeType>
                    allTimeTypes={allTimeTypes.map(_ => timeTypesConfigMap[_])}
                    timeType={timeType}
                    onTimeTypeChange={(changedType, checked) => {
                        const newTypes = allTimeTypes.filter(_ => _ === changedType ? checked : timeType.includes(_));
                        workloadOnSaveSettings?.({
                            type: 'TimeType' as any,
                            parentSettingsPathKeys: ['timeType'],
                            valueBySettingNameMap: allTimeTypes.reduce((acc, cur) => ({ ...acc, [cur]: newTypes.includes(cur) }), {})
                        });
                    }}
                />
            }
        ];
        const menu: IWithColumns & { farCommands?: IContextualMenuItem[] } = {
            type: "Columns",
            displayFields: controlSettings?.usage?.displayFields ?? [],
            onDisplayFieldsChange: (f: string[]) => { workloadOnSaveSettings?.(PreferenceUpdates.displayFields(f)); },
            farCommands
        }
        return {
            config: viewConfig,
            menu: menu,
            render: (entities: ITask[]) => <PersistWorkloadGrid 
                readOnly={readOnly} 
                entity={entity}
                tasks={entities}                
                taskFakeFields={datacontext.fakeFields}
                calendar={datacontext.calendar}
                calendarsById={datacontext.calendarsById}
                updateAssignmentByDay={actions.updateAssignmentsByDay}                         
                controlSettings={controlSettings}
                onSaveSettings={onSaveSettings}
                defaultSort={settings.orderBy?.length
                    ? { fieldName: settings.orderBy[0], direction: Metadata.SortDirection.ASC }
                    : undefined}
                onScaleChanged={timelineChange => onScaleChanged(entity.resourceIds, () => {}, timelineChange)} /> 
        }
    }

    private _getTaskVariance = (updatedTask: ITask): TaskVariance | undefined => {
        const task = this.state.tasks.find(_ => _.id === updatedTask.id);
        return calculateTaskVariance(updatedTask, task, this.props.datacontext.calendar);
    }

    private _isHierarchyView = (): boolean => {
        const context = this._hierarchy.getContext();
        return TaskHierarchy.isHierarchyView(this.props.datacontext.activeSourceInfo.type, context);
    }

    private _getControlSettings = (): SubListControlSettings & WorkloadControlSettings => {
        const { controlSettings, datacontext } = this.props;
        const sourceSettings = controlSettings[datacontext.activeSourceInfo.type.toString()];
        return {
            ...sourceSettings,
            timeline: {
                ...sourceSettings?.timeline,
                ...controlSettings.timeline
            },
            usage: {
                ...sourceSettings?.usage,
                ...controlSettings.usage
            },
            viewType: controlSettings!.viewType
        }
    }

    private _onSaveSettings = (update: UserViewPreferencesUpdate, sendToServer?: boolean) => {
        const { datacontext, onSaveSettings } = this.props;
        if (update.type === 'Timeframe' || update.type === 'Quantization') {
            onSaveSettings?.(update, sendToServer);
            return;
        }

        onSaveSettings?.({
            ...update,
            parentSettingsPathKeys: [datacontext.activeSourceInfo.type.toString(), ...update.parentSettingsPathKeys]
        }, sendToServer);
    }

    private _onListItemRender = (entity: ITask, index: number, field: Metadata.Field, defaultRender: () => JSX.Element): JSX.Element => {
        if (field.name === nameof<ITaskAttrs>("Name") && this._isDraftTask(entity)) {
            return <div className='grid-editable-cell in-edit-mode' >
                <TextEditor
                    required
                    value={entity.attributes.Name}
                    onSave={name => this._createTaskFromDraft(name, entity)}
                    onCancel={() => this._removeDraftTask(entity.id)} />
            </div>;
        }
        return defaultRender();
    }

    private _createDraftTaskBefore = (beforeEntityId: string): void => {
        const { tasks } = this.state;
        const beforeEntity = tasks.find(_ => _.id === beforeEntityId);
        if (!beforeEntity || !this.props.actions.buildNew) {
            return;
        }
        const draft: ITask = {
            ...this.props.actions.buildNew(),
            id: uuidv4()
        };
        draft.attributes.Group = beforeEntity.attributes.Group;

        draft.hierarchy = {
            parentId: beforeEntity.hierarchy.parentId,
            isParent: false,
            outlineLevel: beforeEntity.hierarchy.outlineLevel,
            parentIds: beforeEntity.hierarchy.parentIds
        };

        const newTasks = [...this.state.tasks];
        newTasks.splice(tasks.indexOf(beforeEntity), 0, draft);
        this.setState(prevState => ({
            tasks: newTasks,
            draftTasks: [...prevState.draftTasks, { id: draft.id, insertBeforeId: beforeEntityId }]
        }));
    }

    private _createDraftSubtask = (parentId: string): void => {
        const newTasks = [...this.state.tasks];
        const parentTask = newTasks.find(_ => _.id === parentId);
        if (!parentTask || !this.props.actions.buildNew) {
            return;
        }

        const draft: ITask = {
            ...this.props.actions.buildNew(),
            id: uuidv4()
        };
        draft.attributes.Group = parentTask.attributes.Group;

        draft.hierarchy = {
            parentId: parentId,
            isParent: false,
            outlineLevel: parentTask.hierarchy.outlineLevel + 1,
        };

        const updatedParentTask = {
            ...parentTask,
            hierarchy: {
                ...parentTask.hierarchy,
                isParent: true
            }
        };

        const firstSubtask = newTasks
            .filter(_ => !this._isDraftTask(_) && _.hierarchy.parentId === parentId)
            .sort((a: ITask, b: ITask) => sortTasksByRank(a, b))[0];

        newTasks.splice(newTasks.indexOf(parentTask), 1, updatedParentTask, draft);

        this.setState(prevState => ({
            tasks: newTasks,
            draftTasks: [...prevState.draftTasks, { id: draft.id, parentId, insertBeforeId: firstSubtask?.id }]
        }), () => this._hierarchy.expand(parentId));
    }

    private _createTaskFromDraft = (name: string, draft: ITask) => {
        const draftInfo = this.state.draftTasks.find(_ => _.id === draft.id);
        const index = this.state.tasks.findIndex(_ => _.id === draft.id);
        if (!draftInfo || index === -1) {
            this._removeDraftTask(draft.id);
            return;
        }

        this.props.actions.create!({
            id: draft.id,
            attributes: { ...draft.attributes, Name: name },
            externalData: draft.externalData,
            insertBeforeId: draftInfo.insertBeforeId,
            parentId: draftInfo.parentId
        }, undefined, { inlineEdit: true });

        const tasks = [...this.state.tasks];
        tasks[index] = { ...tasks[index], attributes: { ...tasks[index].attributes, Name: name } };
        this.setState(prevState => ({
            tasks,
            draftTasks: prevState.draftTasks.filter(_ => _.id !== draft.id)
        }));

        analytics.trackEvent('Add new PPM Express task', this.props.user, { itemTitle: name });
    }

    private _removeDraftTask = (id: string) => {
        const parentTaskIds = new Set(this.state.tasks
            .filter(_ => _.id === id && _.hierarchy.parentId)
            .map(_ => _.hierarchy.parentId!));
        const remainingTasks = this.state.tasks.filter(_ => _.id !== id);
        const tasks = remainingTasks
            .map(_ => parentTaskIds.has(_.id)
                ? { ..._, hierarchy: { ..._.hierarchy, isParent: remainingTasks.some(__ => __.hierarchy.parentId === _.id) } }
                : _);

        this.setState(prevState => ({
            tasks,
            draftTasks: prevState.draftTasks.filter(_ => _.id !== id)
        }));
    }

    private _create = (data: ICreationData<ITaskAttrs>) => {
        const withByDays = this._getControlSettings().viewType === Views.Usage;
        this.props.actions.create!(data, withByDays);
        analytics.trackEvent("Create PPM Express task", this.props.user, { itemTitle: data.attributes.Name });
    }

    private _update = (id: string, changes: Partial<ITaskAttrs>, options?: UpdateOptions) => {
        const subentity = this.state.tasks.find(_ => _.id === id);
        if (changes?.Predecessor?.length && subentity?.isAutoMode && subentity?.hierarchy.isParent) {
            this.props.notificationsActions.pushNotification({
                type: NotificationsStore.NotificationType.Warn,
                message: 'The Start/Due date could not be calculated from the related Predecessor because the Summary task dates are rolled up from its child tasks.'
            });
        }
        const controlSettings = this._getControlSettings();
        const reloadByDays = controlSettings.viewType === Views.Usage

        return this.props.actions.update(id, changes, reloadByDays, options);
    }

    private _buildFilterHelper = (props: FilterHelperProps) => {
        return new FilterHelper(props);
    }

    private _buildTimelineRelationCommands = (relation: ITimelineRelation): IContextualMenuItem[] | undefined => {
        if (!relation) {
            return undefined;
        }
        if (relation.isExternal) {
            return undefined;
        }
        return [
            !this.state.readOnly ? {
                key: 'delete',
                title: "Delete",
                iconProps: { iconName: 'Delete', style: { color: 'red' } },
                onClick: () => {
                    const updates: IPatch<ITask>[] = [];
                    const taskId = relation.isReverse ? relation.parent.key : relation.child.key;
                    const predcessorId = relation.isReverse ? relation.child.key : relation.parent.key;
                    const task = this.props.entity.tasks?.find(_ => _.id === taskId);
                    if (task) {
                        const predecessors = task.attributes.Predecessor?.filter((_: IPredecessorInfo) => _.id !== predcessorId) ?? [];
                        updates.push({ id: task.id, attributes: { [nameof<ITaskAttrs>("Predecessor")]: predecessors } });
                        this.props.actions.bulkUpdate(updates);
                    }
                }
            } : undefined
        ].filter(notUndefined);
    }

    private removeTaskGroupDialogMessageBuilder = (removeGroup: Metadata.Group) => {
        const metadataGroups = this._getGroups(this.props)!;
        return `Are you sure you want to delete Group "${removeGroup.name}"?
All tasks within the group will be automatically moved to "${(metadataGroups.filter(_ => _.id !== removeGroup.id).find(_ => _.isDefault)
                || metadataGroups.filter(_ => _.id !== removeGroup.id)[0]).name}" Group.`;
    }

    private _openTask = (task: ITask) => {
        const query = new URLSearchParams(this.props.location.search);
        query.set(EntityType.Task.toLowerCase(), task.id);

        this.props.history.replace({ search: query.toString(), state: this.props.location.state });
    }

    private _getGroups(props: Props): Metadata.Group[] | undefined {
        return props.datacontext.groups as Metadata.Group[] | undefined;
    }

    private saveGroup = (group: GroupInfo) => {
        if (group.id) {
            this.props.actions.updateGroup(group as Metadata.Group);
        } else {
            this.props.actions.createGroup(group as Metadata.IBaseGroupInfo);
        }
    }

    private removeGroup = (group: Metadata.Group) => {
        this.props.actions.removeGroup(group.id);
    }

    private reorderGroups = (groups: Metadata.Group[]) => {
        this.props.actions.reorderGroups(groups.map(_ => _.id));
    }

    private getCalculateTaskGroupSummaryFunc = (props: Props) => {
        const activeSourceType = props.datacontext.activeSourceInfo.type;
        const entity = props.entity;
        if (activeSourceType === SourceType.Ppmx) {
            switch (entity.settings.progressCalculationType) {
                case ProgressCalculationType.StoryPoints:
                    return TasksTimeline.calculateTaskGroupSummaryUsingStoryPoints;
                case ProgressCalculationType.AverageProgress:
                    return TasksTimeline.calculateTaskGroupSummaryUsingAverageProgress;
                default:
                    return TasksTimeline.calculateTaskGroupSummaryUsingEffort;
            }
        }

        if ([SourceType.MondayCom].includes(activeSourceType)) {
            return (tasks: ITask[], calendar: CalendarDataSet): GroupSummary => {
                const types = props.connectionTaskTypes ?? [];
                return TasksTimeline.calculateTaskGroupSummaryUsingAverageProgress(tasks, calendar, (_) => types.includes(_.attributes.Type!));
            };
        }

        if ([SourceType.O365Planner].includes(activeSourceType)) {
            return TasksTimeline.calculateTaskGroupSummaryUsingAverageProgress;
        }

        return TasksTimeline.calculateTaskGroupSummaryUsingEffort;
    }

    private _buildGroups(props: Props): EntityGroup[] | undefined {
        const calculateTaskGroupSummary = this.getCalculateTaskGroupSummaryFunc(props);

        const metadataGroups = this._getGroups(props);
        if (!metadataGroups) {
            return undefined;
        }
        let groupedTasks: Dictionary<ITask[]> = (props.entity.tasks || []).reduce(
            (result: Dictionary<ITask[]>, item: ITask) => ({
                ...result,
                [item.attributes.Group?.id || ungroupedGroup.key]: [...(result[item.attributes.Group?.id || ungroupedGroup.key] || []), item],
            }), {});

        const groups: EntityGroup[] = metadataGroups.filter(_ => _.isShown)
            .map<EntityGroup>(_ => ({
                key: _.id,
                name: _.name,
                color: _.color,
                count: (groupedTasks[_.id] || []).length,
                data: calculateTaskGroupSummary(groupedTasks[_.id] || [], props.datacontext.calendar)
            }));

        let groupsMap = metadataGroups.reduce((result: Dictionary<Metadata.Group>, _) => ({ ...result, [_.id]: _ }), {});
        let missingGroups = (props.entity.tasks || []).filter(_ => !!_.attributes.Group && !groupsMap[_.attributes.Group.id])
            .reduce((result: Metadata.IGroupInfo[], _) => (result.findIndex(__ => __.id === _.attributes.Group!.id) === -1 ? [...result, _.attributes.Group!] : result), []);

        if (missingGroups.length > 0) {
            groups.push(...missingGroups.map<EntityGroup>(_ => ({
                key: _.id,
                name: `${_.name} (Missing)`,
                color: _.color,
                count: (groupedTasks[_.id] || []).length,
                data: calculateTaskGroupSummary(groupedTasks[_.id] || [], props.datacontext.calendar)
            })));
        }

        if (!!groupedTasks[ungroupedGroup.key]) {
            groups.push({
                ...ungroupedGroup,
                count: (groupedTasks[ungroupedGroup.key] || []).length,
                data: calculateTaskGroupSummary(groupedTasks[ungroupedGroup.key] || [], props.datacontext.calendar)
            });
        }

        return groups;
    }

    private renderGroupFooter(group: EntityGroup, user: UserState, tenant?: TenantState): JSX.Element | null {
        const aiEnabled = Subscription.contains(this.props.tenant.subscription, PPMFeatures.AiInsights);
        return <div className="with-group-marker group-footer align-center">
            <div className="group-marker" style={{ backgroundColor: group.color }} />
            <div className="container">
                <InlineInput
                    inlineAddInputProps={{
                        types: [{ label: "Task", key: "task" }],
                        onSave: (name) => this._saveInlineTask(name, group.key)
                    }}
                    items={[{
                        iconName: 'PPMXAiGenerated',
                        onClick: () => {
                            analytics.trackEvent("Start with AI Schedule", user);
                            this.setState({ isAISchedulePanelOpen: true, selectedGroup: group })
                        },
                        label: "Generate with AI",
                        isVisible: !!(tenant && Subscription.contains({ features: tenant.subscription.allFeatures}, PPMFeatures.AiInsights)),
                        title: !aiEnabled
                            ? "To use AI features, PPM Insights AI should be enabled in the tenant by PPM Express Administrator"
                            : undefined,
                        disabled: !Subscription.contains(this.props.tenant.subscription, PPMFeatures.AiInsights),
                        className: 'ai-generate-btn generate-with-ai'
                    }]} />
            </div>
        </div>
    }

    private _saveInlineTask = (name: string, groupKey: string) => {
        const group = this._getGroups(this.props)?.find(_ => _.id === groupKey);
        const newTask = this.props.actions.buildNew!();
        newTask.id = uuidv4();
        newTask.attributes.Name = name;
        newTask.attributes.Group = group && { id: group.id, name: group.name, color: group.color };

        this.setState({ tasks: [...this.state.tasks, newTask] });

        this._inlineTasksToCreate.push({
            id: newTask.id,
            attributes: newTask.attributes,
            externalData: newTask.externalData
        });
        this._debouncedOnSaveInlineTask();
        analytics.trackEvent('Add new PPM Express task', this.props.user, { itemTitle: name });
    }

    private _bulkSaveInlineTasks = () => {
        if (this._inlineTasksToCreate.length) {
            this.props.actions.bulkCreate(this._inlineTasksToCreate, { inlineEdit: true });
            this._inlineTasksToCreate = [];
        }
    }

    private _updateTaskDates = (task: ITask, startDate?: Date, dueDate?: Date) => {
        const { resources, entity } = this.props;
        const { calendar, calendarsById } = this.props.datacontext;
        const tasksMap = toDictionaryById(this.state.tasks);
        if (!isTaskPredecessorHierarchyValid(task, tasksMap)) {
            this.props.notificationsActions.pushNotification({
                type: NotificationsStore.NotificationType.Error,
                message: messages.notAllowedByHierarchyRemoveIt
            });
        }

        if (task.isAutoMode && task.hierarchy.isParent) {
            this.props.actions.update(task.id, {});
            return;
        }

        // StartDate resize should update Duration, not move DueDate
        const isResize = startDate !== undefined && dueDate === undefined || startDate === undefined && dueDate !== undefined;

        const assigneeCalendars = getAssigneeCalendars(entity.settings.useResourceCalendar, task.attributes.AssignedTo, calendar, resources, calendarsById);

        // Bug 17135: the day boundaries come from the TASK calendar, not the project calendar alone — a bar dropped on
        // the weekend a disjoint (Sat–Sun) resource works has no project working times to read a day start/end from.
        const patch: Partial<ITaskAttrs> = {};
        if (startDate !== undefined) {
            patch.StartDate = startDate.setTimeOfDay(utils.dayStartMinutesFor(startDate, assigneeCalendars, calendar)).toUniversalIsoDateTimeString();
        } else if (dueDate !== undefined) {
            patch.DueDate = dueDate.setTimeOfDay(task.attributes.Duration === 0
                ? utils.dayStartMinutesFor(dueDate, assigneeCalendars, calendar)
                : utils.dayEndMinutesFor(dueDate, assigneeCalendars, calendar)).toUniversalIsoDateTimeString();
        }
        const dictatedDates = TaskScheduleCalculator.GetDictatedDates(
            task.attributes.Predecessor,
            tasksMap,
            calendar,
            assigneeCalendars,
            entity.settings?.shiftZeroDayMilestoneWithFSPredecessorToNextWorkingDay ?? true,
            task);
        if (!isResize && startDate && dictatedDates.startDate && dictatedDates.startDate > startDate) {
            patch.StartDate = dictatedDates.startDate.toUniversalIsoDateTimeString();
        }

        // A Gantt MOVE is a Start move: it sends the Start ALONE, exactly like the inline grid and the edit panel, and
        // the server derives Duration/Due from it. Bundling the client-derived Duration/Due made it read as an explicit
        // span edit: on Fixed Units that recomputes Effort instead of preserving it (Bug 17036), and on either type a
        // requested span suppresses the contraction that keeps a stretched span from ratcheting up on every move. A bar
        // dropped on a day none of the assignees works is rejected by the engine, which is the intended answer.
        // A RESIZE genuinely defines the span, so it keeps sending the reconciled triple — a bare Due reads as a MOVE
        // server-side, so the Start/Duration have to come with it.
        if (!isResize && patch.StartDate !== undefined) {
            this.props.actions.update(task.id, patch);
            return;
        }

        const extra = handleDuration(task.attributes, patch, calendar, resources, calendarsById, entity.settings.useResourceCalendar, !isResize);
        this.props.actions.update(task.id, { ...patch, ...extra });
    }

    private _buildGrouping = (): TimelineList.TimelineGroupingProps => ({
        getGroupRow: (group: EntityGroup, rows: TimelineList.IRow[]): TimelineList.IRow => TasksTimeline.getGroupRow(group)
    });

    private _moveToGroup = (selectedItems: ITask[], group: Metadata.Group) => {
        if (selectedItems.length) {
            const updates: IPatch<ITask>[] = [];
            selectedItems.forEach(_ => {
                _.attributes.Group = group && { id: group.id, name: group.name, color: group.color };
                updates.push({ id: _.id, attributes: { Group: _.attributes.Group } });
            });
            this.props.actions.bulkUpdate(updates);
        }
    }

    private _link = (selectedItems: ITask[]) => {
        if (selectedItems.length < MIN_COUNT_TO_LINK) {
            return;
        }

        let hasNotAllowedByHierarchy = false;
        const predecessorsMap = buildPredecessorsMap(this.props.entity.tasks);
        const updates: IPatch<ITask>[] = [];
        for (let i = 1; i < selectedItems.length; i++) {
            const predecessor = selectedItems[i - 1];
            const task = selectedItems[i];
            if (!isAllowedAsPredecessorByHierarchy(task, predecessor)) {
                hasNotAllowedByHierarchy = true;
                continue;
            }

            if (!predecessorsMap[predecessor.id]?.[task.id] && !task.attributes.Predecessor?.find(_ => _.id === predecessor.id)) {
                task.attributes.Predecessor = [
                    ...task.attributes.Predecessor ?? [],
                    { id: predecessor.id, name: predecessor.attributes.Name, lag: 0, type: PredecessorType.FinishToStart }];
                updates.push({ id: task.id, attributes: { Predecessor: task.attributes.Predecessor } });
            }
        }

        if (hasNotAllowedByHierarchy) {
            this.props.notificationsActions.pushNotification({
                type: NotificationsStore.NotificationType.Warn,
                message: messages.notAllowedByHierarchy
            });
        }

        if (!updates.length) {
            return;
        }

        this.props.actions.bulkUpdate(updates);
    }

    private _unlink = (selectedItems: ITask[]) => {
        if (!selectedItems.length) {
            return;
        }

        const updates: IPatch<ITask>[] = [];
        selectedItems.forEach(task => {
            if (!!task.attributes.Predecessor?.length) {
                task.attributes.Predecessor = [];
                updates.push({ id: task.id, attributes: { Predecessor: task.attributes.Predecessor } });
            }
        })
        if (updates.length) {
            this.props.actions.bulkUpdate(updates);
        }
    }

    private _setProgress = (selectedItems: ITask[], value: number) => {
        if (!selectedItems.length) {
            return;
        }

        const taskStatusDescriptor = StatusDescriptorFactory.createStatusDescriptorFor(EntityType.Task, this.props.fields)!;
        const updates: IPatch<ITask>[] = selectedItems
            .filter(_ => allowEditTaskProgress(this.state.readOnly, _, this.props.user.resource?.id))
            .map(_ => {
                if (value == 100 && _.attributes.Progress != 100) {
                    _.attributes.Status = taskStatusDescriptor.getCategoryDefaultStatusValue(StatusCategory.Done);
                }

                const attrUpdates: Partial<ITaskAttrs> = {
                    Progress: value,
                    ...TaskProgressCalculator.RecalculateByProgress(this.props.entity, _, value)
                };
                _.attributes = { ..._.attributes, ...attrUpdates };
                return { id: _.id, attributes: attrUpdates };
            });
        this.props.actions.bulkUpdate(updates);
    }

    private _setCalculationMode = (isAutoMode: boolean, selectedItems: ITask[]) => {
        if (!selectedItems.length) {
            return;
        }

        const selectedIds = selectedItems.map(_ => _.id);
        if (!isAutoMode) {
            this.props.actions.updateCalculationMode(false, selectedIds);
            return;
        }

        post<ModeSwitchRecalculationInfo>(`api/project/${this.props.entity.id}/task/mode/recalculation`, { ids: selectedIds })
            .then(info => {
                if (info.required) {
                    this.setState({ modeSwitchRecalculation: { ids: selectedIds, info } });
                } else if (selectedIds.length > 1) {
                    this.setState({ isOpenAutoModeConfirmation: selectedIds });
                } else {
                    this.props.actions.updateCalculationMode(true, selectedIds);
                }
            })
            // The pre-flight is not a gate: on failure switch anyway and let the server pick the default direction.
            .catch(() => this.props.actions.updateCalculationMode(true, selectedIds));
    }

    private _isEffortProject = () => this.props.entity.settings.progressCalculationType === ProgressCalculationType.Effort;

    private _setTaskType = (taskType: TaskType, selectedItems: ITask[]) => {
        if (!selectedItems.length) {
            return;
        }

        this.props.actions.updateTaskType(taskType, selectedItems.map(_ => _.id));
    }

    private _reportTime = (item: ITask, seconds: number, date: Date) => {
        this.props.actions.reportTime(item, seconds, date);
    }

    private _showSetBaselineConfirmation = (selectedItems: ITask[]) => {
        this.setState({ setBaselineSelectedEntities: selectedItems })
    }

    private _setBaseline = (selectedItems: ITask[]) => {
        if (selectedItems.length) {
            this.props.actions.setBaseline(selectedItems.map(_ => _.id));
            analytics.trackEvent('Set tasks baseline', this.props.user, { count: selectedItems.length });
        }
    }

    private _clone = (selectedItems: ITask[]) => {
        if (selectedItems.length) {
            const toCreate: ICreationData[] = [];
            const map: { [id: string]: string } = {};
            selectedItems.forEach(_ => {
                const newItem = ({
                    id: uuidv4(),
                    attributes: { ..._.attributes },
                    externalData: {},
                    isAutoMode: _.isAutoMode,
                    taskType: _.taskType,
                    parentId: _.hierarchy.parentId && map[_.hierarchy.parentId]
                });
                map[_.id] = newItem.id!;
                toCreate.push(newItem);
            })

            this.props.actions.bulkCreate(toCreate);
        }
    }

    private _assignTo = (selectedItems: ITask[], value: IUserInfo[]) => {
        if (selectedItems.length) {
            const updates: IPatch<ITask>[] = [];
            selectedItems.forEach(_ => {
                _.attributes.AssignedTo = value;
                updates.push({ id: _.id, attributes: { AssignedTo: _.attributes.AssignedTo } });
            });
            this.props.actions.bulkUpdate(updates);
        }
    }

    private _setAsMilestone = (selectedItems: ITask[]) => {
        if (!selectedItems.length) {
            return;
        }

        const hasSkippedTasks = selectedItems.some(_ => !_.attributes.DueDate);
        const updates: IPatch<ITask>[] = selectedItems
            .filter(_ => !!_.attributes.DueDate && !_.attributes.IsMilestone)
            .map(_ => {
                _.attributes.IsMilestone = true;
                return { id: _.id, attributes: { IsMilestone: true } };
            });

        if (updates.length) {
            this.props.actions.bulkUpdate(updates);
        }

        if (hasSkippedTasks) {
            this.props.notificationsActions.pushNotification({
                type: NotificationsStore.NotificationType.Warn,
                message: '"Is Milestone" cannot be set for tasks without the Due Date.'
            });
        }
    }

    private _buildSelectionModeCommands = (selectedItems: ITask[]): IContextualMenuItem[] => {
        const metadataGroups = this._getGroups(this.props);
        const allowChangeProgress = allowEditTasksProgress(this.state.readOnly, selectedItems, this.props.user.resource?.id);
        const isHierarchyView = this._isHierarchyView();

        return [
            allowChangeProgress ? {
                key: "setProgress",
                name: "Set progress",
                title: "Set one of the predefined values into Progress, % for the selected tasks.\nFor tasks in Auto mode progress-related fields will be automatically recalculated.\nFor tasks in Manual mode progress-related fields will need to be manually updated",
                iconProps: { iconName: "Completed" },
                subMenuProps: {
                    items: ProgressScale.map((_) => ({
                        key: _.toString(),
                        name: formatValue(_, Metadata.FormatType.Percent),
                        title: `Set ${_.toString()}% Progress for the selected tasks`,
                        className: "progress-formatter",
                        onRenderIcon: () => <ProgressIcon progress={_} />,
                        iconProps: {},
                        onClick: () => this._setProgress(selectedItems, _),
                    })),
                },
            } : undefined,
            !this.state.readOnly ? {
                key: "Indent",
                name: `Indent`,
                title: !isHierarchyView ? FeatureForAllTasksFilterMessage :
                    'Indent the selected Tasks to reposition them lower in the hierarchy, one level at a time,\nthereby transforming them into subtasks of the nearest preceding Task in the Tasks list',
                iconProps: { iconName: "PPMXIndentArrow" },
                disabled: !isHierarchyView,
                onClick: () => this._indent(selectedItems),
            } : undefined,
            !this.state.readOnly ? {
                key: "Outdent",
                name: `Outdent`,
                title: !isHierarchyView ? FeatureForAllTasksFilterMessage :
                    'Outdent the selected Tasks to reposition them higher in the hierarchy, one level at a time,\nthereby removing their subtask status and placing them at the same level as their nearest preceding Task',
                iconProps: { iconName: "PPMXOutdentArrow" },
                disabled: !isHierarchyView,
                onClick: () => this._outdent(selectedItems),
            } : undefined,
            !this.state.readOnly ? {
                key: "Link",
                name: `Link`,
                title: "Link the selected Tasks by creating Finish-to-Start dependencies between them",
                iconProps: { iconName: "AddLink" },
                onClick: () => this._link(selectedItems),
            } : undefined,
            !this.state.readOnly ? {
                key: "Unlink",
                name: `Unlink`,
                title: "Remove the link between the selected Tasks, thereby removing all predecessors from the selected Tasks",
                iconProps: { iconName: "RemoveLink" },
                onClick: () => this._unlink(selectedItems),
            } : undefined,
            !this.state.readOnly ? {
                key: "assignTo",
                name: "Assign to",
                title: "Assign one or multiple Resource to the selected Tasks",
                iconProps: { iconName: "PPMXResource" },
                subMenuProps: {
                    items: [
                        {
                            key: "personPicker",
                            onRender: () => (
                                <div style={{ maxWidth: "280px" }}>
                                    <AssigneePickerInput
                                        inputProps={{ placeholder: selectedItems[0]?.attributes.AssignedTo?.length ? undefined : "Select resource" }}
                                        value={selectedItems[0]?.attributes.AssignedTo}
                                        multichoice={true}
                                        onChanged={(value) => {
                                            this._assignTo(selectedItems, value);
                                        }}
                                        searchUrl="api/resource/find"
                                    />
                                </div>
                            ),
                        },
                    ],
                },
            } : undefined,
            !this.state.readOnly
                && this.props.datacontext.activeSourceInfo.type === SourceType.Ppmx ? {
                key: "setAsMilestone",
                name: "Set As Milestone",
                title: "Set Is Milestone for the selected tasks",
                iconProps: { iconName: "PPMXMilestone" },
                onClick: () => this._setAsMilestone(selectedItems),
            } : undefined,
            !this.state.readOnly && this.props.entity.isEditable ? {
                key: "SetBaseline",
                name: `Set Baseline`,
                title: "Take a snapshot of selected Tasks that includes information about task’s Start Date,\nDue Date, Duration, Effort and Original Estimate",
                iconProps: { iconName: "PPMXBaseline" },
                onClick: () => this._showSetBaselineConfirmation(selectedItems),
            } : undefined,
            !this.state.readOnly ? {
                key: "clone",
                name: "Clone",
                title: "Clone the selected Tasks; cloned tasks will be added to the end of the Tasks list",
                iconProps: { iconName: "Copy" },
                onClick: () => this._clone(selectedItems),
            } : undefined,
            !this.state.readOnly ? {
                key: "SetMode",
                name: "Set Mode",
                title: "Set Progress calculation mode for the selected Tasks",
                iconProps: { iconName: "PPMXAutoSchedule" },
                subMenuProps: { items: this.buildScheduleModeMenu(selectedItems, true, false) },
            } : undefined,
            !this.state.readOnly && this._isEffortProject() ? {
                key: "SetTaskType",
                name: "Set Task Type",
                title: "Set the Task Type for the selected PPM Express Tasks",
                iconProps: { iconName: "CheckboxComposite" },
                subMenuProps: { items: this.buildTaskTypeMenu(selectedItems, false) },
            } : undefined,
            !this.state.readOnly && selectedItems.some(_ => _.taskType === TaskType.FixedUnits) ? {
                key: "SetEffortDriven",
                name: "Effort Driven",
                title: "Set Effort Driven for the selected Fixed Units Tasks",
                iconProps: { iconName: "UserEvent" },
                subMenuProps: { items: this.buildEffortDrivenMenu(selectedItems, false) },
            } : undefined,
            !this.state.readOnly ? {
                    key: "calculate",
                    name: "Calculate",
                    iconProps: { iconName: "AutoEnhanceOn" },
                    onClick: () => this._rollupTasks(selectedItems),
                    subMenuProps: {
                        items: [{
                            key: "CalculateRollup",
                            name: `Calculate Progress`,
                            title: "Calculate Progress, % and progress-related fields for the selected Tasks in the Manual mode:\nrollup calculation is performed for summary Tasks,\nand horizontal calculation is performed for non-summary Tasks",
                            iconProps: { iconName: "PPMXCalculateProgress" },
                            onClick: () => this._rollupTasks(selectedItems),                       
                        },
                        {
                            key: "apply-calendars",
                            name: "Apply calendars",
                            iconProps: { iconName: "PublicCalendar" },
                            onClick: () => this.props.actions.applyCalendars(selectedItems.map(_ => _.id)),
                        }]
                    }
                } : undefined,
            !this.state.readOnly && metadataGroups ? {
                key: "moveToGroup",
                name: `Move to Group`,
                title: "Move the selected Tasks to one of the existing Groups",
                iconProps: { iconName: "FabricMovetoFolder" },
                subMenuProps: metadataGroups && {
                    items: metadataGroups.map((_) => ({
                        key: _.id,
                        name: _.name,
                        className: "group",
                        iconProps: { className: "group-color", style: { backgroundColor: _.color } },
                        onClick: () => this._moveToGroup(selectedItems, _),
                    })),
                },
            } : undefined,
        ].filter(notUndefined);
    }

    private _buildActionsCommandItems = (): IContextualMenuItem[] => {
        return [
            !this.state.readOnly && this.props.controlSettings.viewType !== Views.Usage ? {
                key: "ManageGroups",
                name: `Manage Groups`,
                title: "Configure Task Groups",
                iconProps: { iconName: "GroupList" },
                onClick: this.props.switchToConfigureMode,
            } : undefined,
            this._canConfigureTaskForm() ? {
                key: "ConfigureTaskForm",
                name: `Configure Task Form`,
                title: "Define the order of the fields in the task Edit pane for this layout",
                iconProps: { iconName: "FormLibrary" },
                onClick: () => this.setState({ isConfigureTaskFormOpen: true }),
            } : undefined,
            (this.props.entity.isEditable && this.props.datacontext.activeSourceInfo.type !== SourceType.Ppmx) ? {
                key: "CopyToPPMExpress",
                name: `Copy to PPM Express Tasks`,
                title: getCopyScheduleTitle(this.props.datacontext.activeSourceInfo.type),
                iconProps: { iconName: SourceType_.getIconName(SourceType.Ppmx) },
                className: "copy-to-ppmx-menu-item",
                onClick: () => this.props.actions.copyToPpmxSchedule(this.props.datacontext.activeSourceInfo.type)
            } : undefined
        ].filter(notUndefined);
    }

    private _canConfigureTaskForm = (): boolean => {
        return this.props.isEditingLayout
            && this.props.canManageConfiguration
            && !!this.props.actions.saveTaskFormFields
            && this.props.controlSettings.viewType !== Views.Usage;
    }

    private _getConfiguredTaskFormFields = (): string[] | undefined =>
        getTaskFormFields(this.props.taskFormSections, this.props.datacontext.activeSourceInfo.type);

    private _getTaskFormFields = (): string[] => {
        const sourceType = this.props.datacontext.activeSourceInfo.type;
        return buildTaskFormFields(
            getMandatoryEditFields(sourceType, this.props.entity?.settings.progressCalculationType),
            this._getConfiguredTaskFormFields());
    }

    private buildScheduleModeMenu = (selectedItems: ITask[], showTitle: boolean, showSelector: boolean): IContextualMenuItem[] => {
        return [
            {
                key: "Auto",
                name: "Auto",
                title: showTitle ? "Horizontal and vertical (rollup) calculation for progress-related fields is performed automatically" : undefined,
                iconProps: {
                    iconName: selectedItems.length === 1 && showSelector
                        ? selectedItems[0].isAutoMode ? "CheckMark" : ""
                        : "PPMXAutoSchedule"
                },
                onClick: () => this._setCalculationMode(true, selectedItems)
            },
            {
                key: "Manual",
                name: "Manual",
                title: showTitle ? "Horizontal and vertical (rollup) calculation for progress-related fields is performed on-demand" : undefined,
                iconProps: {
                    iconName: selectedItems.length === 1 && showSelector
                        ? !selectedItems[0].isAutoMode ? "CheckMark" : ""
                        : "PPMXManualSchedule"
                },
                onClick: () => this._setCalculationMode(false, selectedItems)
            }
        ];
    }

    private buildTaskTypeMenu = (selectedItems: ITask[], showSelector: boolean): IContextualMenuItem[] => {
        const currentType = selectedItems.length === 1 ? (selectedItems[0].taskType ?? TaskType.Flexible) : undefined;
        return [
            {
                key: "Flexible",
                name: "Flexible",
                iconProps: { iconName: showSelector && currentType === TaskType.Flexible ? "CheckMark" : "" },
                onClick: () => this._setTaskType(TaskType.Flexible, selectedItems)
            },
            {
                key: "FixedUnits",
                name: "Fixed Units",
                iconProps: { iconName: showSelector && currentType === TaskType.FixedUnits ? "CheckMark" : "" },
                onClick: () => this._setTaskType(TaskType.FixedUnits, selectedItems)
            }
        ];
    }

    private _setEffortDriven = (effortDriven: boolean, selectedItems: ITask[]) => {
        const ids = selectedItems.filter(_ => _.taskType === TaskType.FixedUnits).map(_ => _.id);
        if (ids.length) {
            this.props.actions.updateEffortDriven(effortDriven, ids);
        }
    }

    private buildEffortDrivenMenu = (selectedItems: ITask[], singleTask: boolean): IContextualMenuItem[] => {
        const current = selectedItems.length === 1 ? !!selectedItems[0].effortDriven : undefined;
        const onLabel = singleTask ? "Yes" : "On";
        const offLabel = singleTask ? "No" : "Off";
        return [
            {
                key: "EffortDrivenOn",
                name: onLabel,
                iconProps: { iconName: singleTask && current === true ? "CheckMark" : "" },
                onClick: () => this._setEffortDriven(true, selectedItems)
            },
            {
                key: "EffortDrivenOff",
                name: offLabel,
                iconProps: { iconName: singleTask && current === false ? "CheckMark" : "" },
                onClick: () => this._setEffortDriven(false, selectedItems)
            }
        ];
    }

    private _isDraftTask = (task: ITask): boolean => this.state.draftTasks.some(_ => _.id === task.id);

    private _getItemCommands = (selectedItems: ITask[], currentItem?: ITask, filterContext?: SubentitiesListHierarchyContext<ITask>) => {
        if (selectedItems.some(_ => this._isDraftTask(_))) {
            return [];
        }
        const { readOnly, expandedInFilter, tasks } = this.state;
        const metadataGroups = this._getGroups(this.props);
        const selectedItem = selectedItems.length === 1 ? selectedItems[0] : undefined;
        const isHierarchyView = TaskHierarchy.isHierarchyView(this.props.datacontext.activeSourceInfo.type, filterContext);
        const allowChangeProgress = allowEditTasksProgress(readOnly, selectedItems, this.props.user.resource?.id);

        const showExpandHiearchyMenu = !!currentItem && !isHierarchyView
            && tasks.find(_ => _.id === currentItem?.id)?.hierarchy.isParent
            && !this._hierarchy.getParentKey(currentItem);

        const items: IContextualMenuItem[] =
            [
                !readOnly ? {
                    key: 'assignTo',
                    name: 'Assign to',
                    iconProps: { iconName: "PPMXResource" },
                    subMenuProps: {
                        items:
                            [{
                                key: "personPicker",
                                onRender: () => <div style={{ maxWidth: '280px' }}>
                                    <AssigneePickerInput
                                        inputProps={{ placeholder: selectedItems[0]?.attributes.AssignedTo?.length ? undefined : 'Select resource' }}
                                        value={selectedItems[0]?.attributes.AssignedTo}
                                        multichoice={true}
                                        onChanged={(value) => { this._assignTo(selectedItems, value); }}
                                        searchUrl="api/resource/find" /></div>
                            }]
                    }
                } : undefined,
                !readOnly
                    && this.props.datacontext.activeSourceInfo.type === SourceType.Ppmx ? {
                    key: 'setAsMilestone',
                    name: 'Set As Milestone',
                    iconProps: { iconName: "PPMXMilestone" },
                    onClick: () => this._setAsMilestone(selectedItems)
                } : undefined,
                !readOnly && this.props.entity.isEditable ? {
                    key: 'setBaseline',
                    name: 'Set Baseline',
                    iconProps: { iconName: "PPMXBaseline" },
                    onClick: () => this._showSetBaselineConfirmation(selectedItems)
                } : undefined,
                (!readOnly || selectedItems.some(_ => allowEditReadOnlyProgress(selectedItem, this.props.user.resource?.id))) && allowChangeProgress ? {
                    key: 'setProgress',
                    name: 'Set progress',
                    iconProps: { iconName: "Completed" },
                    subMenuProps: {
                        items: ProgressScale.map(_ => (
                            {
                                key: _.toString(),
                                name: formatValue(_, Metadata.FormatType.Percent),
                                className: "progress-formatter",
                                onRenderIcon: () => <ProgressIcon progress={_} />,
                                iconProps: {},
                                onClick: () => this._setProgress(selectedItems, _)
                            }))
                    }
                } : undefined,
                this._buildReportTimeMenuItem(readOnly, selectedItems),
                !readOnly ? { key: 'divider_1', itemType: ContextualMenuItemType.Divider } : undefined,
                !readOnly ? {
                    key: "add-subtask",
                    name: "Add subtask",
                    iconProps: { iconName: "Add" },
                    disabled: !selectedItem || !isHierarchyView,
                    title: !isHierarchyView ? FeatureForAllTasksFilterMessage : undefined,
                    onClick: () => this._createDraftSubtask(selectedItems[0].id)
                } : undefined,
                showExpandHiearchyMenu && !!currentItem && !expandedInFilter.includes(this._hierarchy.getKey(currentItem)) ? {
                    key: "expand-hierarchy",
                    name: "Expand hierarchy",
                    iconProps: { iconName: "PPMXExpandAll" },
                    onClick: () => {
                        this.setState({ expandedInFilter: [...expandedInFilter, this._hierarchy.getKey(currentItem)] });
                        this._hierarchy.expand(currentItem.id, tasks.reduce((lvl, t) => Math.max(lvl, t.hierarchy.outlineLevel), 0));
                    }
                } : undefined,
                showExpandHiearchyMenu && !!currentItem && expandedInFilter.includes(this._hierarchy.getKey(currentItem)) ? {
                    key: "collapse-hierarchy",
                    name: "Collapse hierarchy",
                    iconProps: { iconName: "PPMXCollapseAll" },
                    onClick: () => {
                        this.setState({ expandedInFilter: expandedInFilter.filter(_ => _ !== this._hierarchy.getKey(currentItem)) });
                        this._hierarchy.collapse(currentItem);
                    }
                } : undefined,
                !readOnly ? {
                    key: "outdent-task",
                    name: "Outdent",
                    iconProps: { iconName: "PPMXOutdentArrow" },
                    disabled: !isHierarchyView,
                    title: !isHierarchyView ? FeatureForAllTasksFilterMessage : undefined,
                    onClick: () => this._outdent(selectedItems)
                } : undefined,
                !readOnly ? {
                    key: "indent-task",
                    name: "Indent",
                    iconProps: { iconName: "PPMXIndentArrow" },
                    disabled: !isHierarchyView,
                    title: !isHierarchyView ? FeatureForAllTasksFilterMessage : undefined,
                    onClick: () => this._indent(selectedItems)
                } : undefined,
                !readOnly ? {
                    key: "insert-task-above",
                    name: "Insert task above",
                    iconProps: { iconName: "Insert" },
                    disabled: !selectedItem || !isHierarchyView,
                    title: !isHierarchyView ? FeatureForAllTasksFilterMessage : undefined,
                    onClick: () => this._createDraftTaskBefore(selectedItems[0].id)
                } : undefined,
                !readOnly ? {
                    key: "calculate",
                    name: "Calculate",
                    iconProps: { iconName: "AutoEnhanceOn" },
                    onClick: () => this._rollupTasks(selectedItems),
                    subMenuProps: {
                        items: [{
                            key: "calculate-rollup",
                            name: "Calculate progress",
                            iconProps: { iconName: "PPMXCalculateProgress" },
                            onClick: () => this._rollupTasks(selectedItems),                        
                        },
                        {
                            key: "apply-calendars",
                            name: "Apply calendars",
                            iconProps: { iconName: "PublicCalendar" },
                            onClick: () => this.props.actions.applyCalendars(selectedItems.map(_ => _.id)),
                        }]
                    }
                } : undefined,
                !readOnly ? {
                    key: "link-task",
                    name: "Link",
                    iconProps: { iconName: "AddLink" },
                    onClick: () => this._link(selectedItems)
                } : undefined,
                !readOnly ? {
                    key: "unlink-task",
                    name: "Unlink",
                    iconProps: { iconName: "RemoveLink" },
                    onClick: () => this._unlink(selectedItems)
                } : undefined,
                !readOnly ? {
                    key: 'set-calculation-mode',
                    name: 'Set Mode',
                    iconProps: { iconName: "PPMXAutoSchedule" },
                    subMenuProps: { items: this.buildScheduleModeMenu(selectedItems, false, true) }
                } : undefined,
                !readOnly && this._isEffortProject() ? {
                    key: 'set-task-type',
                    name: 'Set Task Type',
                    iconProps: { iconName: "CheckboxComposite" },
                    subMenuProps: { items: this.buildTaskTypeMenu(selectedItems, true) }
                } : undefined,
                !readOnly && selectedItems.some(_ => _.taskType === TaskType.FixedUnits) ? {
                    key: 'set-effort-driven',
                    name: 'Effort Driven',
                    iconProps: { iconName: "UserEvent" },
                    subMenuProps: { items: this.buildEffortDrivenMenu(selectedItems, true) }
                } : undefined,
                { key: 'divider_2', itemType: ContextualMenuItemType.Divider },
                !readOnly ? {
                    key: 'clone',
                    name: 'Clone Task',
                    iconProps: { iconName: "Copy" },
                    onClick: () => this._clone(selectedItems)
                } : undefined,
                !readOnly && metadataGroups ? {
                    key: 'moveToGroup',
                    name: 'Move to group',
                    iconProps: { iconName: "FabricMovetoFolder" },
                    subMenuProps: {
                        items: metadataGroups.map(_ => (
                            {
                                key: _.id,
                                name: _.name,
                                className: "group",
                                iconProps: { className: "group-color", style: { backgroundColor: _.color } },
                                onClick: () => this._moveToGroup(selectedItems, _)
                            }))
                    }
                } : undefined
            ].filter(notUndefined);

        return items;
    }

    private _buildReportTimeMenuItem = (
        readOnly: boolean | undefined,
        selectedItems: ITask[],

    ): IContextualMenuItem | undefined => {
        if (this.props.entity.isPrivate || !this.props.entity.settings.allowTimeTracking) {
            return undefined;
        }

        if (this.props.user.resource &&
            selectedItems.length > 0 &&
            selectedItems[0].attributes.AssignedTo?.find(_ => _.id === this.props.user.resource?.id)) {

            const hasTimeTrackingFeature = Subscription.containsAny(this.props.tenant.subscription, [PPMFeatures.TimeTracking, PPMFeatures.TimeTrackingEnterprise]);
            const isNewTimeTrackingEnabled = hasTimeTrackingFeature && this.props.tenant.timeTracking.globalSettings.newTimeTrackingEnabled;
            const isDisabled = selectedItems.length !== 1;

            if (isNewTimeTrackingEnabled) {
                return TimeTrackingReportTimeMenu.buildReportTimeMenuItem(
                    (hours: number, date: Date) => this._reportTime(selectedItems[0], hours * 60 * 60, date),
                    isDisabled,
                    this.props.tenant.timeTracking.globalSettings,
                    this.props.periods);
            }
        }

        return undefined;
    }

    private _indent = (selectedItems: ITask[]) => {
        if (selectedItems.length) {
            this.props.actions.indent(selectedItems.map(_ => _.id));
            selectedItems.forEach(_ => {
                const prevtask = this._findPrevTask(_.id);
                if (prevtask && this._hierarchy.getExpandedIds().indexOf(prevtask.id) === -1) {
                    this._hierarchy.expand(prevtask.id);
                }
            });
        }
    }

    private _outdent = (selectedItems: ITask[]) => this.props.actions.outdent(selectedItems.map(_ => _.id));

    private _findPrevTask = (id: string): ITask | undefined => {
        const task = this.state.tasks.find(_ => _.id === id);
        if (!task) {
            return undefined;
        }
        const tasks = this.state.tasks.filter(_ => _.attributes.Group?.id === task?.attributes.Group?.id
            && _.hierarchy.outlineLevel === task?.hierarchy.outlineLevel
            && _.hierarchy.parentId === task?.hierarchy.parentId)
        const index = tasks.findIndex(_ => _.id === id);
        if (index <= 0) {
            return undefined;
        }

        return tasks[index - 1];
    }

    private _getPrefilterItems(): { [K: number]: Metadata.PreFilterOption<ITask>[] } {
        return {
            [SourceType.Ppmx]: this._ppmxPrefilterItems(),
            [SourceType.O365Planner]: defaultPrefilterItems(this.props.firstDayOfWeek),
            [SourceType.Spo]: defaultPrefilterItems(this.props.firstDayOfWeek),
            [SourceType.MondayCom]: defaultPrefilterItems(this.props.firstDayOfWeek),
            [SourceType.VSTS]: this._vstsPrefilterItems(),
            [SourceType.Jira]: this._jiraPrefilterItems(),
            [SourceType.Smartsheet]: defaultPrefilterItems(this.props.firstDayOfWeek),
            [SourceType.MPPFile]: defaultPrefilterItems(this.props.firstDayOfWeek),
            [SourceType.P4W]: defaultPrefilterItems(this.props.firstDayOfWeek),
        }
    }

    private _ppmxPrefilterItems = (): Metadata.PreFilterOption<ITask>[] => {
        const result = defaultPrefilterItems(this.props.firstDayOfWeek);
        const index = result.findIndex(_ => _.key === Metadata.TaskPrefilterKey.late) + 1;
        result.splice(index, 0,
            {
                key: Metadata.TaskPrefilterKey.slipped,
                name: 'Slipped Tasks',
                predicate: _ => _.attributes.Progress !== 100 && !!_.baseline && (
                    (!!_.baseline.startDate && !!_.attributes.StartDate && toDate(_.baseline.startDate)! < toDate(_.attributes.StartDate)!) ||
                    (!!_.baseline.effort && !!_.attributes.Effort && _.baseline.effort < _.attributes.Effort) ||
                    (!!_.baseline.originalEstimate && !!_.attributes.OriginalEstimate && _.baseline.originalEstimate < _.attributes.OriginalEstimate) ||
                    (!!_.baseline.dueDate && !!_.attributes.DueDate && toDate(_.baseline.dueDate)! < toDate(_.attributes.DueDate)!) ||
                    (!!_.baseline.duration && !!_.attributes.Duration && _.baseline.duration < _.attributes.Duration))
            });
        return result;
    }

    private _vstsPrefilterItems = (): Metadata.PreFilterOption<ITask>[] => {
        const { entity, firstDayOfWeek } = this.props;
        const currentIteration = IterationSelect.getCurrent(entity.iterations, SourceType.VSTS);
        const ranges = getDateRanges(firstDayOfWeek);
        return [{
            key: Metadata.TaskPrefilterKey.today, name: 'Today', predicate: InDateRangeFilter(ranges.today.begin, ranges.today.end)
        }, {
            key: Metadata.TaskPrefilterKey.thisweek, name: 'This Week', predicate: InDateRangeFilter(ranges.thisWeek.begin, ranges.thisWeek.end)
        }, {
            key: Metadata.TaskPrefilterKey.currentIteration, name: 'Current Iteration', predicate: (_: ITask) => _.attributes.Iteration === currentIteration?.externalData?.["IterationPath"]
        }];
    }

    private _jiraPrefilterItems = (): Metadata.PreFilterOption<ITask>[] => {
        const { entity, firstDayOfWeek } = this.props;
        const currentIteration = IterationSelect.getCurrent(entity.iterations, SourceType.Jira);
        const ranges = getDateRanges(firstDayOfWeek);
        return [{
            key: Metadata.TaskPrefilterKey.today, name: 'Today', predicate: InDateRangeFilter(ranges.today.begin, ranges.today.end)
        }, {
            key: Metadata.TaskPrefilterKey.thisweek, name: 'This Week', predicate: InDateRangeFilter(ranges.thisWeek.begin, ranges.thisWeek.end)
        }, {
            key: Metadata.TaskPrefilterKey.currentIteration, name: 'Current Iteration', predicate: (_: ITask) => _.attributes.Iteration === currentIteration?.attributes.Name
        }];
    }

    private _checkDnDLimitation(props: Props, prevValue?: boolean): boolean | undefined {
        if (!this._hierarchy.allowDrag()) {
            return undefined;
        }

        if (!prevValue && props.controlSettings.viewType === 'Timeline'
            && props.entity.tasks && props.entity.tasks.length > MAX_ROWS_COUNT_FOR_CORRECT_DND) {
            props.notificationsActions.pushNotification({
                type: NotificationsStore.NotificationType.Info,
                message: "Drag & Drop is not supported for large number of tasks on Timeline View. Please use List View for this purpose."
            });

            return true;
        }

        if (prevValue && props.controlSettings.viewType === 'Details') {
            return false;
        }

        return undefined;
    }

    private _rollupTasks = (selectedItems: ITask[]) => {
        this.props.actions.rollupTasks(selectedItems.map(_ => _.id));
        if (selectedItems.some(_ => !!_.attributes.Predecessor?.length && _.hierarchy?.isParent)) {
            this.props.notificationsActions.pushNotification({
                type: NotificationsStore.NotificationType.Warn,
                message: "The Start/Due date could not be calculated from the related Predecessor because the Summary task dates are rolled up from its child tasks."
            });
        }
    }
}

const DAYS_IN_WEEK_MINUS_ONE = 6; // Days to add to week start to get week end (0-based week calculation)

function getDateRanges(firstDayOfWeek: DayOfWeek) {
    return {
        today: {
            begin: new Date().getBeginOfDay(),
            end: new Date().getEndOfDay()
        },
        thisWeek: {
            begin: new Date().getWeekStartDate(firstDayOfWeek).getBeginOfDay(),
            end: new Date().getWeekStartDate(firstDayOfWeek).addDays(DAYS_IN_WEEK_MINUS_ONE).getEndOfDay()
        }
    }
}

export function calculateTaskVariance(updatedTask: ITask, task: ITask | undefined, calendar: CalendarDataSet): TaskVariance | undefined {
    if (!task?.baseline) {
        return undefined;
    }

    const startDateVariance = task.attributes.StartDate === updatedTask.attributes.StartDate
        ? task.baseline.startDateVariance
        : TaskVarianceCalculator.CalculateDateVariance(updatedTask.attributes.StartDate, task.baseline.startDate, calendar);

    const dueDateVariance = task.attributes.DueDate === updatedTask.attributes.DueDate
        ? task.baseline.dueDateVariance
        : TaskVarianceCalculator.CalculateDateVariance(updatedTask.attributes.DueDate, task.baseline.dueDate, calendar);

    const durationVariance = task.attributes.Duration === updatedTask.attributes.Duration
        ? task.baseline.durationVariance
        : TaskVarianceCalculator.CalculateVariance(updatedTask.attributes.Duration, task.baseline.duration);

    const effortVariance = task.attributes.Effort === updatedTask.attributes.Effort
        ? task.baseline.effortVariance
        : TaskVarianceCalculator.CalculateVariance(updatedTask.attributes.Effort, task.baseline.effort);

    const originalEstimateVariance = task.attributes.OriginalEstimate === updatedTask.attributes.OriginalEstimate
        ? task.baseline.originalEstimateVariance
        : TaskVarianceCalculator.CalculateVariance(updatedTask.attributes.OriginalEstimate, task.baseline.originalEstimate);

    return {
        startDateVariance,
        dueDateVariance,
        durationVariance,
        effortVariance,
        originalEstimateVariance
    }
}

function mapStateToProps(state: ApplicationState, ownProps: ExternalTasksControlProps): StateProps {
    const fields = state.fields[EntityType.Task];
    const projectsList = ownProps.entity.isArchived ? state.archivedProjectsList : state.projectsList;
    const layouts = state.layouts[EntityType.Project];
    return {
        user: state.user,
        resources: state.resources.byId,
        isListLoading: projectsList.tasks.isListLoading || state.resources.isListLoading,
        isListUpdating: projectsList.tasks.isLoading || state.resources.isLoading,
        tenant: state.tenant,
        fields: fields.allIds.map(_ => fields.byId[_]),
        connectionTaskTypes: ownProps.datacontext.activeSourceInfo?.type === SourceType.MondayCom
            ? state.mondayCom.progressCalculationSettings.entities.types
            : undefined,
        firstDayOfWeek: getFirstDayOfWeekSetting(state),
        periods: state.timeReportingPeriods.periods,
        taskFormSections: getTaskFormSections(layouts, ownProps.entity.sections),
        isEditingLayout: !!getEditedLayout(layouts),
        canManageConfiguration: !ownProps.entity.isArchived
            && contains(state.user.permissions.common, CommonOperations.ConfigurationManage)
    };
}

function mergeActionCreators(dispatch: any): ActionsProps {
    return {
        notificationsActions: bindActionCreators(NotificationsStore.actionCreators, dispatch)
    }
}

export default withRouter(connect(mapStateToProps, mergeActionCreators)(TasksControl));

export function getMandatoryEditFields(type: SourceType | null, calculationType?: ProgressCalculationType) {
    if (type === SourceType.Ppmx) {
        if (calculationType === ProgressCalculationType.StoryPoints) {
            return namesof<ITaskAttrs>(['Name', 'Description',
                'StartDate', 'DueDate', 'Duration',
                'Status', 'IsMilestone', 'Group',
                'StoryPoints', 'CompletedStoryPoints', 'Progress',
                'AssignedTo',
                'Predecessor',
                'Tags'
            ]);
        }
        if (calculationType === ProgressCalculationType.AverageProgress) {
            return namesof<ITaskAttrs>(['Name', 'Description',
                'StartDate', 'DueDate', 'Duration',
                'Status', 'Progress', 'IsMilestone',
                'Group', 'Priority', 'Effort',
                'AssignedTo',
                'Predecessor',
                'Tags'
            ]);
        }
        // ProgressCalculationType.Effort
        return namesof<ITaskAttrs>(['Name', 'Description',
            'StartDate', 'DueDate', 'Duration',
            'Status', 'Progress', 'IsMilestone',
            'Effort', 'CompletedWork', 'RemainingWork',
            'AssignedTo',
            'Predecessor',
            'Group', 'Priority', 'StoryPoints',
            'Tags'
        ]);
    }
    if (type === SourceType.O365Planner) {
        return namesof<ITaskAttrs>(['Name',
            'Group', 'Progress', 'Priority',
            'Status', 'StartDate', 'DueDate',
            'AssignedTo',
            'Tags'
        ]);
    }
    if (type === SourceType.Spo) {
        return namesof<ITaskAttrs>(['Name',
            'StartDate', 'DueDate', 'Duration',
            'Status', 'Progress', 'IsMilestone',
            'Effort', 'CompletedWork', 'RemainingWork',
            'AssignedTo',
            'Predecessor',
            'Type', 'Priority', 'WBS',
        ]);
    }
    if (type === SourceType.VSTS) {
        return namesof<ITaskAttrs>(['Name', 'Description',
            'StartDate', 'DueDate', 'StoryPoints',
            'Status', 'State', 'Progress',
            'Type', 'ParentName', 'Parent',
            'Effort', 'CompletedWork', 'RemainingWork',
            'AssignedTo',
            'Iteration', 'AreaPath', 'Priority',
            'Tags'
        ]);
    }
    if (type === SourceType.Jira) {
        return namesof<ITaskAttrs>(['Name', 'Description',
            'StartDate', 'DueDate', 'StoryPoints',
            'Type', 'Iteration', 'Parent',
            'Status', 'State', 'Progress',
            'AssignedTo',
            'Effort', 'CompletedWork', 'RemainingWork',
            'Tags'
        ]);
    }
    if (type === SourceType.MondayCom) {
        return namesof<ITaskAttrs>(['Name', 'Description',
            'Group', 'Progress', 'Priority',
            'Status', 'StartDate', 'DueDate',
            'AssignedTo',
            'Tags'
        ]);
    }
    if (type === SourceType.Smartsheet) {
        return namesof<ITaskAttrs>(['Name', 'Description',
            'StartDate', 'DueDate', 'Duration',
            'Status', 'Progress', 'Priority',
            'AssignedTo',
        ]);
    }
    if (type === SourceType.MPPFile) {
        return namesof<ITaskAttrs>(['Name',
            'StartDate', 'DueDate', 'Duration',
            'Status', 'Progress', 'IsMilestone',
            'Effort', 'CompletedWork', 'RemainingWork',
            'AssignedTo',
            'Predecessor',
            'Type', 'Priority', 'WBS',
        ]);
    }
    if (type === SourceType.P4W) {
        return namesof<ITaskAttrs>(['Name', 'Description',
            'StartDate', 'DueDate', 'Duration',
            'Status', 'Progress', 'IsMilestone',
            'Effort', 'CompletedWork', 'RemainingWork',
            'AssignedTo',
            'Predecessor',
            'Type', 'Priority', 'WBS',
            'Tags'
        ]);
    }

    return [];
}
